export default __webpack_public_path__ + "static/media/btn-more-bg.a7950859.webp";